import React, { useEffect, useState } from 'react';
import { isEmpty, map } from 'lodash';
import common from '../../../common/common';
import Globalizer from '../../../globalizer';
import translateService from '../../../common/translateService';
import { getFeedbacks } from '../../../services/feedbacks/feedbacksService';
import { setStartAndEndIndexes } from '../../../services/pagination/paginationService';
import ReviewStars from '../reviews/ReviewStars.jsx';
import Button from '../../Button.jsx';
import Feedback from './Feedback.jsx';
import './Feedbacks.scss';

const AllFeedbacks = () => {
    Globalizer.init();
    const [feedbacks, setFeedbacks] = useState({
        serviceQualityRatingAverage: 0,
        feedbackCount: 0,
        feedbacks: [],
        sortType: 2,
        percServiceQuality5: 0,
        percServiceQuality4: 0,
        percServiceQuality3: 0,
        percServiceQuality2: 0,
        percServiceQuality1: 0,
        percUseExperience5: 0,
        percUseExperience4: 0,
        percUseExperience3: 0,
        percUseExperience2: 0,
        percUseExperience1: 0,
        writeAFeedbackLink: '',
        feedbacksLink: '',
        isUserAuthenticated: false,
        page: 0,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 0,
    });

    const init = async () => {
        const f = await getFeedbacks();
        setFeedbacks(f);
    };

    useEffect(() => {
        init();
    }, []);

    const changeSortType = async (sortType) => {
        if (sortType === feedbacks.sortType) return;

        const f = await getFeedbacks(0, sortType);
        setFeedbacks(f);
    };

    const handlePageChange = async (pageNumber) => {
        const f = await getFeedbacks(pageNumber, feedbacks.sortType);
        setFeedbacks(f);

        window.scroll({
            top: 0,
            behavior: 'smooth',
        });
    };

    const buildPagination = () => {
        const currentPage = feedbacks.page < 1 ? 1 : feedbacks.page;
        const scrollPages = 5;

        if (feedbacks.totalRecords === 0) return <></>;

        const [startIndex, endIndex] = setStartAndEndIndexes(
            feedbacks.totalPages,
            scrollPages,
            currentPage
        );

        const pages = [];
        for (let i = startIndex; i <= endIndex; i++) {
            pages.push(
                <li
                    key={i}
                    className={`pagination__page ${
                        currentPage === i ? 'pagination__page--active' : ''
                    }`.trim()}>
                    <a
                        onClick={() => {
                            handlePageChange(i);
                        }}>
                        {i}
                    </a>
                </li>
            );
        }

        return (
            <ul className='pagination__pages'>
                {currentPage === 1 ? (
                    <li className='pagination__page pagination__page--inactive'>
                        &#10094;
                    </li>
                ) : (
                    <li className='pagination__page'>
                        <a
                            onClick={() => {
                                handlePageChange(currentPage - 1);
                            }}>
                            &#10094;
                        </a>
                    </li>
                )}
                {startIndex > 1 && (
                    <li className='pagination__page'>
                        <a
                            onClick={() => {
                                handlePageChange(1);
                            }}>
                            1
                        </a>
                    </li>
                )}
                {startIndex > 2 && (
                    <li className='pagination__page pagination__page--inactive'>
                        ...
                    </li>
                )}
                {pages}
                {endIndex < feedbacks.totalPages - 1 && (
                    <li className='pagination__page pagination__page--inactive'>
                        ...
                    </li>
                )}
                {endIndex < feedbacks.totalPages && (
                    <li className='pagination__page'>
                        <a
                            onClick={() => {
                                handlePageChange(feedbacks.totalPages);
                            }}>
                            {feedbacks.totalPages}
                        </a>
                    </li>
                )}
                {currentPage === feedbacks.totalPages ? (
                    <li className='pagination__page pagination__page--inactive'>
                        &#10095;
                    </li>
                ) : (
                    <li className='pagination__page'>
                        <a
                            onClick={() => {
                                handlePageChange(currentPage + 1);
                            }}>
                            &#10095;
                        </a>
                    </li>
                )}
            </ul>
        );
    };

    return (
        <>
            <div className='feedbacks-image'>
                <img
                    src={`https://d1lzo2tvee88v.cloudfront.net/feedback-${common.getSite()}.webp`}
                    alt='feedbacks'
                />
            </div>
            <div className='all-feedbacks'>
                <div className='feedbacks-heading'>
                    <h1>
                        {translateService.interpolate(
                            `feedbacks.feedbacksTitle`,
                            {
                                sitename: common.getSiteCommercialName(),
                            }
                        )}
                    </h1>
                    <h4>
                        {translateService.interpolate(`feedbacks.subheading`, {
                            tot: feedbacks.totalRecords,
                            average: Globalizer.formatNumber(
                                feedbacks.serviceQualityRatingAverage,
                                1
                            ),
                        })}
                    </h4>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: translateService.interpolate(
                                `feedbacks.description`,
                                {
                                    sitename: common.getSiteCommercialName(),
                                }
                            ),
                        }}
                    />
                    <div className='feedbacks-button-container'>
                        <Button
                            className='feedbacks-button'
                            text={translateService.get(
                                `feedbacks.writeAReview`
                            )}
                            onClick={() => {
                                window.location = common.getSiteUrl(
                                    feedbacks.writeAFeedbackLink
                                );
                            }}
                        />
                    </div>
                </div>
                <div className='feedbacks-text'>
                    {!isEmpty(feedbacks.feedbacks) ? (
                        <div className='feedbacks-ratings-container'>
                            <h3>
                                {translateService.get(
                                    `feedbacks.ratingSummary`
                                )}
                            </h3>
                            <div className='feedbacks-ratings'>
                                <div className='feedbacks-rating'>
                                    <h4>
                                        {translateService.get(
                                            `form.labels.serviceQualityVote`
                                        )}
                                    </h4>
                                    <div className='feedbacks-rating-container'>
                                        <div className='feedbacks-rating-row'>
                                            <p>{`${feedbacks.percServiceQuality5}%`}</p>
                                            <p>
                                                <ReviewStars
                                                    average={5}
                                                    maxRating={5}
                                                />
                                            </p>
                                            <p>
                                                {translateService.get(
                                                    `form.ratings.excellent`
                                                )}
                                            </p>
                                        </div>
                                        <div className='feedbacks-rating-row'>
                                            <p>{`${feedbacks.percServiceQuality4}%`}</p>
                                            <p>
                                                <ReviewStars
                                                    average={4}
                                                    maxRating={5}
                                                />
                                            </p>
                                            <p>
                                                {translateService.get(
                                                    `form.ratings.good`
                                                )}
                                            </p>
                                        </div>
                                        <div className='feedbacks-rating-row'>
                                            <p>{`${feedbacks.percServiceQuality3}%`}</p>
                                            <p>
                                                <ReviewStars
                                                    average={3}
                                                    maxRating={5}
                                                />
                                            </p>
                                            <p>
                                                {translateService.get(
                                                    `form.ratings.average`
                                                )}
                                            </p>
                                        </div>
                                        <div className='feedbacks-rating-row'>
                                            <p>{`${feedbacks.percServiceQuality2}%`}</p>
                                            <p>
                                                <ReviewStars
                                                    average={2}
                                                    maxRating={5}
                                                />
                                            </p>
                                            <p>
                                                {translateService.get(
                                                    `form.ratings.poor`
                                                )}
                                            </p>
                                        </div>
                                        <div className='feedbacks-rating-row'>
                                            <p>{`${feedbacks.percServiceQuality1}%`}</p>
                                            <p>
                                                <ReviewStars
                                                    average={1}
                                                    maxRating={5}
                                                />
                                            </p>
                                            <p>
                                                {translateService.get(
                                                    `form.ratings.bad`
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='feedbacks-rating'>
                                    <h4>
                                        {translateService.get(
                                            `form.labels.useExperienceVote`
                                        )}
                                    </h4>
                                    <div className='feedbacks-rating-container'>
                                        <div className='feedbacks-rating-row'>
                                            <p>{`${feedbacks.percUseExperience5}%`}</p>
                                            <p>
                                                <ReviewStars
                                                    average={5}
                                                    maxRating={5}
                                                />
                                            </p>
                                            <p>
                                                {translateService.get(
                                                    `form.ratings.excellent`
                                                )}
                                            </p>
                                        </div>
                                        <div className='feedbacks-rating-row'>
                                            <p>{`${feedbacks.percUseExperience4}%`}</p>
                                            <p>
                                                <ReviewStars
                                                    average={4}
                                                    maxRating={5}
                                                />
                                            </p>
                                            <p>
                                                {translateService.get(
                                                    `form.ratings.good`
                                                )}
                                            </p>
                                        </div>
                                        <div className='feedbacks-rating-row'>
                                            <p>{`${feedbacks.percUseExperience3}%`}</p>
                                            <p>
                                                <ReviewStars
                                                    average={3}
                                                    maxRating={5}
                                                />
                                            </p>
                                            <p>
                                                {translateService.get(
                                                    `form.ratings.average`
                                                )}
                                            </p>
                                        </div>
                                        <div className='feedbacks-rating-row'>
                                            <p>{`${feedbacks.percUseExperience2}%`}</p>
                                            <p>
                                                <ReviewStars
                                                    average={2}
                                                    maxRating={5}
                                                />
                                            </p>
                                            <p>
                                                {translateService.get(
                                                    `form.ratings.poor`
                                                )}
                                            </p>
                                        </div>
                                        <div className='feedbacks-rating-row'>
                                            <p>{`${feedbacks.percUseExperience1}%`}</p>
                                            <p>
                                                <ReviewStars
                                                    average={1}
                                                    maxRating={5}
                                                />
                                            </p>
                                            <p>
                                                {translateService.get(
                                                    `form.ratings.bad`
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}
                    <div className='feedbacks-allFeedbacks'>
                        <h2>
                            {translateService.get(`feedbacks.allFeedbacks`)}
                        </h2>
                    </div>
                    {isEmpty(feedbacks.feedbacks) && (
                        <p>{translateService.get(`feedbacks.noFeedbacks`)}</p>
                    )}
                </div>
                <div className='feedbacks-sort'>
                    <div>
                        <strong>
                            {translateService.get(`feedbacks.sortBy`)}
                        </strong>
                    </div>
                    <div
                        onClick={() => {
                            changeSortType(2);
                        }}
                        className={`feedbacks-sort-item ${
                            feedbacks.sortType === 2 ? 'active' : ''
                        }`.trim()}
                        title={translateService.get(
                            `feedbacks.sortByBestRatingTitle`
                        )}>
                        {translateService.get(`feedbacks.sortByBestRating`)}
                    </div>
                    <div
                        onClick={() => {
                            changeSortType(1);
                        }}
                        className={`feedbacks-sort-item ${
                            feedbacks.sortType === 1 ? 'active' : ''
                        }`.trim()}
                        title={translateService.get(
                            `feedbacks.sortByMostRecentTitle`
                        )}>
                        {translateService.get(`feedbacks.sortByMostRecent`)}
                    </div>
                    <div
                        onClick={() => {
                            changeSortType(3);
                        }}
                        className={`feedbacks-sort-item ${
                            feedbacks.sortType === 3 ? 'active' : ''
                        }`.trim()}
                        title={translateService.get(
                            `feedbacks.sortByWorstRating`
                        )}>
                        {translateService.get(`feedbacks.sortByWorstRating`)}
                    </div>
                </div>
                <div className='feedbacks'>
                    {map(feedbacks.feedbacks, (feedback, idx) => (
                        <Feedback
                            key={idx}
                            feedback={feedback}
                            isUserAuthenticated={feedbacks.isUserAuthenticated}
                        />
                    ))}
                </div>
                <div className='feedbacks-footer'>
                    {!isEmpty(feedbacks.feedbacks) && buildPagination()}
                </div>
            </div>
        </>
    );
};

export default AllFeedbacks;
